import type { ApolloCache } from '@frameio/graphql-client';
import type { Project } from '@frameio/graphql-client/generated';
import { preloadImage } from '@frameio/utils';
import { imageUploadClient } from '../../shared';
import { updateProjectImages } from '../cache-ops';

export const uploadAndCacheProjectImage = (
  url: string,
  blob: Blob,
  project: Pick<Project, 'id' | 'images'>,
  cache: ApolloCache<any>
) =>
  imageUploadClient(url, blob, () => {
    preloadImage(project.images.imageBase, () =>
      updateProjectImages(cache, project)
    );
  });

export const uploadProjectImage = (
  url: string | null,
  blob: Blob | null,
  cb: () => void
) => {
  if (url && blob) {
    imageUploadClient(url, blob, cb);
    return;
  }
  cb();
};
